export default __webpack_public_path__ + "static/hiranandani-c2503828b98fd92c075aa1fcb458d04d.jpg";